(() => {
  'use strict';

  const roots = new Map();

  function initialize(root) {
    if (roots.has(root)) return;

    const links = Array.from(root.querySelectorAll('.cm-bf-toc a[href], .cm-bf-nav a[href], [data-cm-bf-chapters] a[href]'));
    const chapters = new Map();

    for (const link of links) {
      let url;
      let id;

      try {
        url = new URL(link.getAttribute('href'), window.location.href);
        id = decodeURIComponent(url.hash.slice(1));
      } catch {
        continue;
      }

      if (!id || url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.search !== window.location.search) continue;

      const target = document.getElementById(id);
      if (!target || !root.contains(target)) continue;

      if (!chapters.has(target)) chapters.set(target, []);
      chapters.get(target).push(link);
    }

    if (!chapters.size) return;

    const ordered = Array.from(chapters.keys()).sort((a, b) => {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    const controller = new AbortController();
    let frame = 0;
    let current = null;

    function update() {
      frame = 0;
      const offset = Math.min(window.innerHeight * .3, 220);
      let active = ordered[0];

      for (const target of ordered) {
        if (target.getBoundingClientRect().top <= offset) active = target;
        else break;
      }

      if (active === current) return;
      current = active;

      for (const [target, chapterLinks] of chapters) {
        for (const link of chapterLinks) {
          const selected = target === active;
          link.classList.toggle('is-active', selected);
          if (selected) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        }
      }
    }

    function requestUpdate() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true, signal: controller.signal });
    window.addEventListener('resize', requestUpdate, { passive: true, signal: controller.signal });
    window.addEventListener('hashchange', requestUpdate, { signal: controller.signal });
    roots.set(root, () => {
      controller.abort();
      if (frame) window.cancelAnimationFrame(frame);
      roots.delete(root);
    });
    requestUpdate();
  }

  function scan(scope = document) {
    if (scope.matches?.('.cm-bf')) initialize(scope);
    scope.querySelectorAll('.cm-bf').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [root, dispose] of roots) {
      if (event.target === root || event.target.contains(root)) dispose();
    }
  });
})();
